import { useEffect, useMemo, useRef, useState } from "react";
import { isLoggedIn as read } from "../module/auth";

// 250709 | 로그인 여부 파악 함수 통일을 위하여 작성 | smyun
// 250905 | 로그인 감지 보강 | smyun FIXME
// 프론트에서 로그인 넣어주는 쿠키 사용하지 않음으로 변경
/**
 * 로그인 상태를 쿠키와 동기화하여 반환하는 커스텀 훅
 * - 탭 간 로그인/로그아웃 반영 (localStorage + storage 이벤트 활용)
 * 보강 >
 * - auth.ts 로 이벤트 분리
 * - 쿠키(KMLN+KMUI)가 있는지에 따라 로그인 여부 판단
 * - 쿠키 직접 읽기 (document.cookie)
 * - cross-tab 동기화: storage 이벤트, BroadcastChannel
 * - 포커스/가시성 변경 시 재검증
 * - 저강도 폴링(안전망)
 */

const AUTH_BC = "auth-channel";
const AUTH_LS_KEY = "auth:event";

export function useLoginStatus(): boolean {
    const [logged, setLogged] = useState<boolean>(() => read());
    const ticking = useRef(false);

    // 로그인 여부 체크
    const check = useMemo(
        () => () => {
            if (ticking.current) return;
            ticking.current = true;
            const next = read();
            setLogged((prev) => (prev === next ? prev : next));
            ticking.current = false;
        },
        []
    );

    // 다른 탭의 로그인/로그아웃 신호 수신(storage 이벤트)
    useEffect(() => {
        const onStorage = (e: StorageEvent) => {
            if (e.key === AUTH_LS_KEY) check();
        };
        window.addEventListener("storage", onStorage);
        let bc: BroadcastChannel | null = null;
        try {
            bc = new BroadcastChannel(AUTH_BC);
            bc.onmessage = () => check();
        } catch {}

        // 포커스/가시성 변경 시 재검증
        const onFocusOrShow = () => check();
        window.addEventListener("focus", onFocusOrShow);
        document.addEventListener("visibilitychange", onFocusOrShow);

        // 저강도 폴링(안전망)
        const id = window.setInterval(check, 15000);

        return () => {
            window.removeEventListener("storage", onStorage);
            window.removeEventListener("focus", onFocusOrShow);
            document.removeEventListener("visibilitychange", onFocusOrShow);
            bc?.close();
            window.clearInterval(id);
        };
    }, [check]);

    return logged;
}

// export function useLoginStatus(): boolean {
//     const [cookies] = useCookies(["KMLN"]);
//     const [isLogin, setIsLogin] = useState<boolean>(!!cookies.KMLN);

//     // 쿠키 상태를 재확인하는 함수
//     const checkLogin = () => {
//         const cookieString = document.cookie;
//         return cookieString.includes("KMLN=1");
//     };

//     // storage 이벤트: 다른 탭에서 로그인/로그아웃 감지
//     useEffect(() => {
//         const handleStorage = (e: StorageEvent) => {
//             // cookies.KMUN; // 쿠키 다시 확인
//             if (e.key === "loginSync" || e.key === "logoutSync") {
//                 // 리렌더
//                 setIsLogin(checkLogin());
//             }
//         };

//         window.addEventListener("storage", handleStorage);
//         return () => window.removeEventListener("storage", handleStorage);
//     }, []);

//     // 현재 탭에서 쿠키 변경 감지 (예: 수동 삭제, 만료 등)
//     useEffect(() => {
//         setIsLogin(!!cookies.KMLN);
//     }, [cookies.KMLN]);

//     return isLogin;
// }
